import React, { useEffect, useState } from 'react'
import { Button } from '@material-tailwind/react';
import { addNewFournisseurApi, updateFournisseurApi } from 'api/fournisseur';

function FournisseurForm({ closePopup, fournisseurFormAction, showToast, selectedFournisseur }) {
  const [fournisseurName, setFournisseurName] = useState('')

  useEffect(() => {
    getInitialData()
  }, [selectedFournisseur])

  const getInitialData = () => {
    try {
      if (selectedFournisseur) {
        setFournisseurName(selectedFournisseur.Name || '')
      } else {
        setFournisseurName('')
      }
    }
    catch (err) {
      console.log(err)
    }
  }

  const handleAddFournisseur = async () => {
    try {
      await addNewFournisseurApi(fournisseurName)
      showToast('success', 'Fournisseur ajouté')
      closePopup("Reload");
    }
    catch (err) {
      showToast('error', `${err?.response?.data?.error}`)
    }
  }

  const handleEditeFournisseur = async () => {
    try {
      await updateFournisseurApi(fournisseurName, selectedFournisseur._id)
      showToast('success', 'Fournisseur modifié')
      closePopup("Reload");
    }
    catch (err) {
      showToast('error', `${err?.response?.data?.error}`)
    }
  }

  const handleCancelOp = () => {
    closePopup("Close");
  };

  return (
    <form>
      <div className="mt-2 grid grid-cols-1 gap-5 md:grid-cols-3">
        <div>
          <label htmlFor="" className="text-md font-bold text-navy-700">
            Nom du fournisseur
          </label>
          <input
            type="text"
            id=""
            placeholder="Nom du fournisseur"
            className={`flex w-full items-center justify-center rounded-xl border bg-white/0 p-2 text-sm outline-none`}
            value={fournisseurName}
            disabled={fournisseurFormAction === "show"}
            onChange={e => setFournisseurName(e.target.value)}
          />
        </div>
      </div>

      {
        fournisseurFormAction === "edite" &&
        <div className="mt-5">
        <Button
          variant="gradient"
          color="#236571"
          onClick={() => handleEditeFournisseur()}
          className="mr-1"
        >
          <span>Modifier</span>
        </Button>
        <Button
          variant="text"
          color="#cf503f"
          onClick={() => handleCancelOp()}
          className="mr-1"
        >
          <span>Annuler</span>
        </Button>
        </div>
      }

      {
        fournisseurFormAction === "add" &&
        <div className="mt-5">
        <Button
          variant="gradient"
          color="#236571"
          onClick={() => handleAddFournisseur()}
          className="mr-1"
        >
          <span>Ajouter</span>
        </Button>
        <Button
          variant="text"
          color="#cf503f"
          onClick={() => handleCancelOp()}
          className="mr-1"
        >
          <span>Annuler</span>
        </Button>
        </div>
      }
    </form>
  )
}

export default FournisseurForm
